module.exports = __webpack_public_path__ + "img/Fc.1e15dbf4.png";